<template>
  <hs-confirm-dialog
    :model-value="isOpen"
    :title="title"
    :message="message"
    :confirm-text="confirmText"
    :cancel-text="cancelText"
    :tone="resolvedTone"
    :loading="loading"
    @update:modelValue="handleModelValue"
    @close="handleClose"
    @confirm="$emit('confirm')"
  />
</template>

<script>
import { HsConfirmDialog } from "@/components/ui";

export default {
  name: "ConfirmationModal",
  components: { HsConfirmDialog },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      default: "Confirm",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    type: {
      type: String,
      default: "warning",
      validator: (value) =>
        ["warning", "danger", "info", "success"].includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["confirm", "close"],
  computed: {
    resolvedTone() {
      return this.type === "info" ? "primary" : this.type;
    },
  },
  methods: {
    handleModelValue(open) {
      if (!open) {
        this.handleClose();
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
